'use client';

import { TabServerTransport } from '@mcp-b/transports';
import { useEffect } from 'react';
import { createMcpServer } from '@/lib/webmcp';

export function WebMcpProvider(): null {
  useEffect(() => {
    const server = createMcpServer();
    const transport = new TabServerTransport({ allowedOrigins: ['*'] });
    server.connect(transport).catch(() => {});
    return () => {
      server.close().catch(() => {});
    };
  }, []);
  return null;
}
